import React, { ReactNode } from "react";

import { RcFile } from "antd/es/upload";

import { Dragger, Icon, IconButton, Spin } from "components";

type UploadFileProps = {
  className?: string;
  id?: string;
  filename?: ReactNode;
  success?: boolean;
  label?: string;
  name?: string;
  helpMessage?: string;
  errorMessage?: string;
  openFileDialogOnClick?: boolean;
  uploading?: boolean;
  beforeUpload?: (file: RcFile) => void;
  onChange?: () => void;
  onDelete?: () => void;
  dataTestId?: string;
};

export const UploadFile = ({
  className = "",
  id = "",
  filename,
  success,
  label,
  name,
  helpMessage,
  errorMessage,
  openFileDialogOnClick = true,
  uploading = false,
  beforeUpload = () => {},
  onChange = () => {},
  onDelete,
}: UploadFileProps) => (
  <>
    <div className="file-upload">
      <Dragger
        action=""
        beforeUpload={beforeUpload}
        className={`${success ? "success" : ""} ${errorMessage ? "error" : ""} ${className}`}
        id={id}
        openFileDialogOnClick={openFileDialogOnClick}
        name={name}
        showUploadList={false}
        onChange={onChange}
      >
        <>
          {success ? (
            <>
              <Icon iconName="tabler/file-check" size="xl" />
              <p className="margin-top-100 margin-bottom-0">"{filename}"</p>

              {onDelete && (
                <div className="trash">
                  <IconButton type="secondary" shape="circle" iconName="tabler/trash" size="small" onClick={onDelete} />
                </div>
              )}
            </>
          ) : uploading ? (
            <Spin />
          ) : (
            <>
              <Icon iconName="klim/plus" size="xl" className="margin-bottom-0" />
              <p className="margin-top-100 margin-bottom-0">{label}</p>
            </>
          )}
        </>
      </Dragger>

      {!success && <p className={`help-message ${errorMessage ? "error" : ""}`}>{errorMessage || helpMessage}</p>}
    </div>
  </>
);
